<template><div><h2>Alert</h2>
<ul>
<li>[fix] Fix onHide callback issue #1023 @jsonviewer</li>
</ul>
<h2>DatetimeRange</h2>
<ul>
<li>[feature] new component #970 @327326724</li>
</ul>
<h2>Popup</h2>
<ul>
<li>[enhance] Better mask transition</li>
<li>[feature] Support tranparent background</li>
<li>[feature] Support less variable: @popup-background-color</li>
</ul>
<h2>Swipeout</h2>
<ul>
<li>[fix] Fix left-menu is shown when swiping right quickly</li>
</ul>
<h2>Toast</h2>
<ul>
<li>[enhance] Reset props every time plugin.show is called #870 @jsonviewer</li>
</ul>
<h2>Date</h2>
<ul>
<li>[feature] Add dateRange tool function</li>
<li>[feature] format support string-type of date</li>
</ul>
<h2>Number</h2>
<ul>
<li>[feature] Add numberRange tool function</li>
</ul>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.9-346.vue?0fea9d98